(function($){
  //requires <div class="js-check-member-nr">...{{NL2GO-EmbedScript with script-Tag}}...</div> to work
  //css class "js-vmnr" means "js-function for validation of member number". formsubmit only with class
  $('.js-check-member-nr').on('submit', 'form:not(.js-vmnr)', function(){
    return false;
  }).on('click', 'form:not(.js-vmnr) button:not([type!="submit"])', function(){
    return false;
  }).on('change', 'form input[placeholder*="Mitgliedsnummer"]', function(){
    var $this = $(this),
      form = $this.closest('form').removeClass('js-vmnr');

    //server based validation: requires result {error:bool, message:string|null}
    $.post(location.origin, {'check-member-nr': this.value}, function(data){
      if (data.error && data.message) {
        $this.after(function(){return $('<div class="Base-formError"></div>').text(data.message);}).each(function(){
          $(this).nextAll('.Base-formError').nextAll('.Base-formError').remove();
        });
      } else {
        $this.nextAll('.Base-formError').remove();
        form.addClass('js-vmnr');
      }
    }, 'json');
  });
})(jQuery);
